module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', {
    staticClass: "px-5 py-5"
  }, [_c('div', {
    staticClass: "d-flex align-center font-weight-bold font-size-16 danger--text"
  }, [_c('v-icon', {
    staticClass: "mr-1 danger--text"
  }, [_vm._v("mdi mdi-delete-outline")]), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2 font-size-14"
  }, [_vm._v("\n            " + _vm._s(_vm.subtitle) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('v-row', {
    staticClass: "d-flex align-center d-flex"
  }, [_c('v-col', [_c('v-btn', {
    staticClass: "font-weight-bold",
    staticStyle: {
      "border": "1.6px solid"
    },
    attrs: {
      "color": "#df4f4f",
      "outlined": "",
      "depressed": "",
      "block": "",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n                        Batal\n                    ")])], 1), _vm._v(" "), _c('v-col', [_c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "color": "#df4f4f",
      "dark": "",
      "depressed": "",
      "block": "",
      "height": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("\n                        Oke\n                    ")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6edec2ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/global/components/DialogConfirm.vue
// module id = 997
// module chunks = 1